export const UPDATE_SCROLL = 'ui/updateScroll';
export const updateScroll = top => ({
  type: UPDATE_SCROLL,
  payload: {
    top,
  },
});
